
/**
 * Module dependencies.
 */

import { Link } from 'react-router-dom';
import { ReactNode, Ref, forwardRef } from 'react';

/**
 * `Props` type.
 */

type Props = {
  'aria-label'?: string;
  'aria-labelledby'?: string;
  children: ReactNode;
  className?: string;
  disabled?: boolean | undefined;
  onClick?: () => void;
  replace?: boolean;
  role?: string;
  to: any;
};

/**
 * `RouterLink` component.
 */

function RouterLink(props: Props, ref: Ref<HTMLAnchorElement>): JSX.Element {
  const {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    children,
    className,
    disabled = false,
    onClick,
    replace,
    role,
    to
  } = props;

  return (
    <Link
      {...role ? { role } : {}}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      className={className}
      innerRef={ref}
      onClick={onClick}
      replace={replace}
      to={to}
    >
      {children}
    </Link>
  );
}

/**
 * Wrapped `RouterLink`.
 */

const WrappedRouterLink = forwardRef<HTMLAnchorElement, Props>(RouterLink);

/**
 * Export `RouterLink` component.
 */

export { WrappedRouterLink as RouterLink };
